export enum PRODUCT_CONFIGURATION_TRANSITION {
  LOGISTIC_SERVICE_ACTIVE = 'logistic_service_active',
  SHIPMENT_TRANSIT_TO_DESTINATION = 'shipment_transit_to_destination'
}

export enum CONFIGURATION_BLOCKER_REASON_CODE {
  INCOMPLETE_CONFIGURATION = 'INCOMPLETE_CONFIGURATION',
  UNCONFIRMED_ADDITIONAL_ACTION = 'UNCONFIRMED_ADDITIONAL_ACTION'
}

export type TProductConfigurationSummaryContextType = 'logistic_service' | 'shipment';

export interface IProductConfigurationSummaryContext {
  type: TProductConfigurationSummaryContextType;
  logisticServiceId?: number;
  shipmentId?: number;
  orderId?: number;
  originPlace?: string;
  destinationPlace?: string;
}

export interface IProductConfigurationSummaryCounts {
  productCount: number;
  configurationCount: number;
  incompleteCount: number;
  unconfirmedAdditionalActionsCount: number;
}

export interface IProductConfigurationSummaryAdditionalAction {
  uuid: string;
  actionId: number;
  actionName: string;
  description?: string;
  confirmedAt?: string | null;
  isPending: boolean;
}

export interface IProductConfigurationSummaryConfigFlags {
  isIncomplete: boolean;
  hasUnconfirmedAdditionalActions: boolean;
  requiresAdditionalActionsOnComplete: boolean;
}

export interface IProductConfigurationSummaryConfiguration {
  id: number;
  uuid: string;
  name: string;
  configClassName: string;
  configClassId: number;
  status?: {
    statusId?: number;
    statusName?: string;
  };
  additionalActions: IProductConfigurationSummaryAdditionalAction[];
  flags: IProductConfigurationSummaryConfigFlags;
}

export interface IProductConfigurationSummaryProduct {
  productId: number;
  name?: string;
  serial?: string;
  configurations: IProductConfigurationSummaryConfiguration[];
}

export interface IProductConfigurationTransitionBlocker {
  reasonCode: CONFIGURATION_BLOCKER_REASON_CODE | string;
  productId: number;
  productConfigId: number;
  productConfigUuid: string;
  configClassId: number;
  configClassName: string;
  message: string;
}

export interface IProductConfigurationTransitionReadiness {
  transition: string;
  applies: boolean;
  allowed: boolean;
  canUpdateStatus: boolean;
  blockers: IProductConfigurationTransitionBlocker[];
}

export interface IProductConfigurationSummaryResponse {
  context: IProductConfigurationSummaryContext;
  summary: IProductConfigurationSummaryCounts;
  products: IProductConfigurationSummaryProduct[];
  transitionReadiness?: IProductConfigurationTransitionReadiness;
}

export interface IConfigurationTransitionBlockedApiError {
  message?: string;
  transition?: string;
  blockers?: IProductConfigurationTransitionBlocker[];
  logisticServiceId?: number;
  shipmentId?: number;
}
